import { CatchAll } from '~/error/catch';
import { FieldsUpdate } from './dto/fields-update.dto';
import { CustomersFilter } from '~/entities/customer';
import axios, { AxiosInstance } from 'axios';
import { config } from '~/config';
import { FindOptions } from '~/api/index';
import { omit } from 'lodash';

export class ValuesApi {
  protected readonly api: AxiosInstance;

  constructor() {
    this.api = axios.create({
      baseURL: `${config.contactsApiUrl}`,
      withCredentials: true,
      validateStatus: (status) => status >= 200 && status < 500,
    });
  }

  @CatchAll()
  async updateByFieldId(payload: FieldsUpdate) {
    return this.api.post('update-by-field', payload);
  }

  @CatchAll()
  async assignTags(payload: {
    tagFieldId: string;
    values: string[];
    filters: CustomersFilter[];
    included?: string[];
  }) {
    return this.api.post('tags', payload);
  }

  @CatchAll()
  async removeTags(payload: {
    tagFieldId: string;
    values: string[];
    filters: CustomersFilter[];
    included?: string[];
  }) {
    return this.api.post('delete-tags', payload);
  }

  @CatchAll()
  async getUploadingPhones(uploadId: string) {
    return this.api
      .get(`phones/upload/${uploadId}`)
      .then((result) => result.data);
  }

  @CatchAll()
  async create<T>(dto: any) {
    return this.api.post<T>('', dto);
  }

  @CatchAll()
  async getOne<T>(id: string, query?: FindOptions) {
    return this.api.get<T>(`/${id}`, { params: query });
  }

  @CatchAll()
  async findMany<TResponse = any, TQuery = any>(query?: TQuery) {
    return this.api.get<TResponse>('', { params: query });
  }

  @CatchAll()
  async update<T extends object>(id: string, dto: T) {
    return this.api.patch(`/${id}`, omit(dto, ['id']));
  }

  @CatchAll()
  async delete(id: string) {
    return this.api.delete(`/${id}`);
  }
}
